export class EntFinancialIndicatorsFilter {

  periodStart: string | null;
  periodEnd: string | null;
  governmentIds: number[] | null;
  page: number;
  size: number;
  deleted: boolean;

  constructor(init?: Partial<EntFinancialIndicatorsFilter>) {
    this.periodStart = null;
    this.periodEnd = null;
    this.governmentIds = null;
    this.page = 1; 
    this.size = 30; 
    this.deleted = false; 

    if (init) {
      Object.assign(this, init);
    }
  }
}
